/**
 * 登录管理，包含数字等级、财富（用户）等级、明星（主播）等级
 * coin  数字等级，
 * rich  财富等级
 * star  明星等级
 * @author lianghua.fu
 * @date 2020-10-14 11:49:35
 */

type ConfigItem = {
  values: Array<number>;
  names: Array<string>;
};

type Config = {
  coin: ConfigItem;
  rich: ConfigItem;
  star: ConfigItem;
  nobility: ConfigItem;
};

const config: Config = {
  coin: {
    values: [
      0, 100, 1000, 3000, 5000, 10000, 15000, 20000, 30000, 40000, 50000, 65000,
      80000, 100000, 120000, 150000, 180000, 220000, 260000, 300000, 350000,
      400000, 450000, 500000, 560000, 630000, 700000, 770000, 840000, 920000,
      1000000, 1100000, 1200000, 1300000, 1400000, 1500000, 1600000, 1700000,
      1800000, 1900000, 2000000, 2100000, 2200000, 2300000, 2400000, 2500000,
      2620000, 2740000, 2880000, 3020000, 3180000, 3340000, 3500000, 3680000,
      3860000, 4060000, 4275000, 4500000, 4750000, 5000000, 5275000, 5550000,
      5825000, 6100000, 6400000, 6700000, 7000000, 7300000, 7650000, 8000000,
      8350000, 8750000, 9150000, 9550000, 10000000, 10500000, 11000000,
      11600000, 12200000, 12800000, 13500000, 14200000, 15000000, 15800000,
      16600000, 17400000, 18300000, 19200000, 20100000, 21000000, 22000000,
      23000000, 24000000, 25000000, 26000000, 27000000, 28000000, 29000000,
      30000000, 31200000, 32400000, 33600000, 34800000, 36000000, 37200000,
      38400000, 39600000, 40800000, 42200000, 43600000, 45000000, 46400000,
      47800000, 49200000, 50600000, 52000000, 53500000, 55000000, 56750000,
      58500000, 60500000, 62750000, 65000000, 67500000, 70000000, 72500000,
      75000000, 78000000, 81000000, 84000000, 87500000, 91000000, 95000000,
      99000000, 103500000, 108000000, 113000000, 118000000, 123500000,
      129000000, 135000000, 141000000, 147500000, 154000000, 161000000,
      168000000, 175500000, 183000000, 191000000, 199000000, 207500000,
      216000000, 225000000, 234500000, 244000000, 253500000, 263500000,
      273500000, 286000000, 298500000, 313500000, 328500000, 343500000,
      361000000, 378500000, 396000000, 416000000, 436000000, 458000000,
      480000000, 504000000, 528000000, 554000000, 580000000, 608000000,
      636000000, 666000000, 696000000, 726000000, 758000000, 790000000,
      822000000, 856000000, 890000000, 926000000, 962000000, 1000000000,
      1038000000, 1078000000, 1118000000, 1158000000, 1198000000, 1238000000,
      1283000000, 1328000000, 1378000000, 1428000000, 1483000000, 1538000000,
      1598000000, 1658000000, 1718000000, 1778000000, 1838000000, 1898000000,
      1958000000, 2018000000, 2078000000, 2138000000, 2198000000, 2258000000,
      2328000000, 2398000000, 2468000000, 2538000000, 2608000000, 2678000000,
      2748000000, 2818000000, 2888000000, 2958000000, 3038000000, 3118000000,
      3198000000, 3278000000, 3358000000, 3438000000, 3518000000, 3598000000,
      3678000000, 3758000000, 3848000000, 3938000000, 4028000000, 4118000000,
      4208000000, 4298000000, 4388000000, 4478000000, 4568000000, 4658000000,
    ],
    names: [],
  },
  rich: {
    values: [
      0, 1000, 5000, 15000, 30000, 50000, 80000, 150000, 300000, 500000, 700000,
      1000000, 1500000, 2000000, 2500000, 3500000, 5000000, 7000000, 10000000,
      15000000, 21000000, 28000000, 36000000, 45000000, 55000000, 70000000,
      108000000, 168000000, 253500000, 458000000, 758000000, 1158000000,
      1658000000, 2258000000, 2958000000, 3758000000, 4658000000,
    ],
    names: [
      '庶民',
      '一富',
      '二富',
      '三富',
      '四富',
      '五富',
      '六富',
      '七️富',
      '八富',
      '九富',
      '十富',
      '举人',
      '贡士',
      '进士',
      '知府',
      '巡抚',
      '总督',
      '尚书',
      '太傅',
      '太师',
      '丞相',
      '藩王',
      '郡王',
      '亲王',
      '诸侯',
      '王爷',
      '皇帝',
      '大帝',
      '玉帝',
      '天尊',
      '至尊之神',
      '纵横三界',
      '执掌乾坤',
      '乾坤圣王',
      '三界帝君',
      '六界神尊',
      '破碎虚空',
    ],
  },
  star: {
    values: [
      0, 2000, 12000, 34000, 70000, 140000, 240000, 360000, 500000, 640000,
      840000, 1100000, 1400000, 1800000, 2200000, 2800000, 3400000, 4000000,
      4600000, 5400000, 6200000, 7200000, 8400000, 9600000, 10800000, 12000000,
      14000000, 16000000, 18000000, 20000000, 24000000, 28000000, 32000000,
      36000000, 40000000, 46000000, 56000000, 66000000, 76000000, 86000000,
      96000000, 108000000, 120000000, 132000000, 144000000, 156000000,
      176000000, 196000000, 216000000, 236000000, 256000000, 296000000,
      336000000, 396000000, 456000000, 536000000, 616000000, 696000000,
      776000000, 896000000, 1016000000, 1136000000, 1336000000, 1536000000,
      1736000000, 1936000000, 2136000000, 2436000000, 2736000000, 3036000000,
      3336000000, 3636000000, 4036000000, 4436000000, 4836000000, 5236000000,
    ],
    names: [
      '0星',
      '红星1',
      '红星2',
      '红星3',
      '红星4',
      '红星5',
      '五星1',
      '五星2',
      '五星3',
      '五星4',
      '五星5',
      '黄钻1',
      '黄钻2',
      '黄钻3',
      '黄钻4',
      '黄钻5',
      '白冠1',
      '白冠2',
      '白冠3',
      '白冠4',
      '白冠5',
      '白冠6',
      '白冠7',
      '白冠8',
      '白冠9',
      '白冠10',
      '蓝冠1',
      '蓝冠2',
      '蓝冠3',
      '蓝冠4',
      '蓝冠5',
      '蓝冠6',
      '蓝冠7',
      '蓝冠8',
      '蓝冠9',
      '蓝冠10',
      '橙冠1',
      '橙冠2',
      '橙冠3',
      '橙冠4',
      '橙冠5',
      '橙冠6',
      '橙冠7',
      '橙冠8',
      '橙冠9',
      '橙冠10',
      '紫冠1',
      '紫冠2',
      '紫冠3',
      '紫冠4',
      '紫冠5',
      '紫冠6',
      '紫冠7',
      '紫冠8',
      '紫冠9',
      '紫冠10',
      '黑冠1',
      '黑冠2',
      '黑冠3',
      '黑冠4',
      '黑冠5',
      '黑冠6',
      '黑冠7',
      '黑冠8',
      '黑冠9',
      '黑冠10',
      '金冠1',
      '金冠2',
      '金冠3',
      '金冠4',
      '金冠5',
      '金冠6',
      '金冠7',
      '金冠8',
      '金冠9',
      '金冠10',
    ],
  },
  nobility: {
    values: [1, 2, 3, 4, 5, 6, 7],
    names: [
      '行天御史',
      '驰天督统',
      '亢天将军',
      '凌天元帅',
      '极天王者',
      '傲天皇帝',
      '昊天圣帝',
    ],
  },
};

// 等级信息
type LevelInfo = {
  // 等级
  level: number;
  // 等级名
  name: string;
  // 等级总共所需的柠檬、维C
  value: number;
};

type CoinLevelInfo = LevelInfo & {
  richLevel: number;
};

// 等级类型
enum LevelType {
  // 数字等级
  coin = 'coin',
  // 财富等级
  rich = 'rich',
  // 主播等级
  star = 'star',
}

// 主播等级
type StarLevel = {
  // 当前的等级
  level: number;
  // 下一级
  nextLevel: number;
  // 等级名称
  name: string;
  // 所需维C
  bean: number;
  // 当前等级所需维C数
  levelBean: number;
  levelBeanText: string;
  // 当前等级多出的维C数
  extraBean: number;
  extraBeanText: string;
  // 升级到下一级所需维C数
  upBean: number;
  upBeanText: string;
  // 当前级别百分比 带百分号
  percent: string;
};

/**
 * 数字等级
 */
type CoinLevel = {
  // 当前的等级
  level: number;
  // 当前的财富等级
  richLevel: number;
  // 下一级
  nextLevel: number;
  // 等级名称
  name: string;
  // 所需柠檬数
  coin: number;
  // 当前等级所需柠檬数
  levelCoin: number;
  levelCoinText: string;
  // 当前等级多出的柠檬数
  extraCoin: number;
  extraCoinText: string;
  // 升级到下一级所需柠檬数
  upCoin: number;
  upCoinText: string;
  // 当前级别百分比  带百分号
  percent: string;
};

/**
 * 财富等级
 */
type RichLevel = {
  // 当前的等级
  level: number;
  // 下一级
  nextLevel: number;
  // 等级名称
  name: string;
  // 所需柠檬数
  coin: number;
  // 当前等级所需柠檬数
  levelCoin: number;
  levelCoinText: string;
  // 当前等级多出的柠檬数
  extraCoin: number;
  extraCoinText: string;
  // 升级到下一级所需柠檬数
  upCoin: number;
  upCoinText: string;
  // 当前级别百分比  带百分号
  percent: string;
};

/**
 * 获取数字等级
 * @param  {Number} coin 柠檬
 * @return {Object}      等级信息
 */
function _getCoinLevel(coin: number = 0): CoinLevel {
  var len = config.coin.values.length;
  var level = _getLevelIndex(LevelType.coin, coin, 0, len - 1);
  var richLen = config.rich.values.length;
  var richLevel = _getLevelIndex(LevelType.rich, coin, 0, richLen - 1);
  var nextValue = config.coin.values[level + 1] || 0;
  var value = config.coin.values[level];
  var levelCoin = nextValue - value;

  if (nextValue) {
    return {
      level: level, // 当前等级
      richLevel: richLevel,
      nextLevel: level + 1,
      name: level + '级', // 等级名称  //config.coin.names[level],
      coin: value, // 累计所需柠檬数
      levelCoin: levelCoin, // 等级所需柠檬数
      levelCoinText: formatVal(levelCoin), // 等级所需柠檬数
      extraCoin: coin - value, // 当前等级多出的柠檬数
      extraCoinText: formatVal(coin - value), // 当前等级多出的柠檬数
      upCoin: nextValue - coin, // 还需多少升级的柠檬数量
      upCoinText: formatVal(nextValue - coin), // 还需多少升级的柠檬数量
      percent: (((coin - value) / levelCoin) * 100).toFixed(2) + '%',
    };
  } else {
    return {
      level: level, // 当前等级
      richLevel: richLevel,
      nextLevel: level,
      name: level + '级', // 等级名称  //config.coin.names[level],
      coin: value, // 累计所需柠檬数
      levelCoin: value, // 等级所需柠檬数
      levelCoinText: formatVal(value), // 等级所需柠檬数
      extraCoin: coin - value, // 当前等级多出的柠檬数
      extraCoinText: formatVal(coin - value), // 当前等级多出的柠檬数
      upCoin: 0, //还需多少升级的柠檬数量
      upCoinText: '0',
      percent: '100%',
    };
  }
}

/**
 * 获取财富等级
 * @param  {Number} coin 柠檬
 * @return {Object}      等级信息
 */
function _getRichLevel(coin: number = 0): RichLevel {
  // coin = coin || 0;
  var len = config.rich.values.length;
  var level = _getLevelIndex(LevelType.rich, coin, 0, len - 1);
  var nextValue = config.rich.values[level + 1] || 0;
  var value = config.rich.values[level];
  var levelCoin = nextValue - value;

  if (nextValue) {
    return {
      level: level, // 当前等级
      nextLevel: level + 1,
      name: config.rich.names[level], // 等级名称  //config.coin.names[level],
      coin: value, // 累计所需柠檬数
      levelCoin: levelCoin, // 等级所需柠檬数
      levelCoinText: formatVal(levelCoin), // 等级所需柠檬数
      extraCoin: coin - value, // 当前等级多出的柠檬数
      extraCoinText: formatVal(coin - value), // 当前等级多出的柠檬数
      upCoin: nextValue - coin, //还需多少升级的柠檬数量
      upCoinText: formatVal(nextValue - coin), //还需多少升级的柠檬数量
      percent: (((coin - value) / levelCoin) * 100).toFixed(2) + '%',
    };
  } else {
    return {
      level: level, // 当前等级
      nextLevel: level,
      name: config.rich.names[level], // 等级名称  //config.coin.names[level],
      coin: value, // 累计所需柠檬数
      levelCoin: value, // 等级所需柠檬数
      levelCoinText: formatVal(value), // 等级所需柠檬数
      extraCoin: coin - value, // 当前等级多出的柠檬数
      extraCoinText: formatVal(coin - value), // 当前等级多出的柠檬数
      upCoin: 0, //还需多少升级的柠檬数量
      upCoinText: '0', //还需多少升级的柠檬数量
      percent: '100%',
    };
  }
}

/**
 * 获得主播等级
 * @param  {Number} bean 柠檬数量
 * @return {Object}      等级信息
 */
function _getStarLevel(bean: number = 0): StarLevel {
  bean = bean || 0;
  var len = config.star.values.length;
  var level = _getLevelIndex(LevelType.star, bean, 0, len - 1);
  var nextValue = config.star.values[level + 1] || 0;
  var value = config.star.values[level];

  var levelBean: number = Math.abs(nextValue - value);

  if (nextValue) {
    return {
      level: level, // 当前等级
      nextLevel: level + 1,
      name: config.star.names[level], // 等级名称  //config.coin.names[level],
      bean: value, // 累计所需柠檬数
      levelBean: levelBean, // 等级所需柠檬数
      levelBeanText: formatVal(levelBean),
      extraBean: bean - value, // 当前等级多出的柠檬数
      extraBeanText: formatVal(bean - value),
      upBean: nextValue - bean, //还需多少升级的柠檬数量
      upBeanText: formatVal(nextValue - bean),
      percent: (((bean - value) / levelBean) * 100).toFixed(2) + '%',
    };
  } else {
    return {
      level: level, // 当前等级
      nextLevel: level,
      name: config.star.names[level], // 等级名称  //config.coin.names[level],
      bean: value, // 累计所需柠檬数
      levelBean: value, // 等级所需柠檬数
      levelBeanText: formatVal(levelBean),
      extraBean: bean - value, // 当前等级多出的柠檬数
      extraBeanText: formatVal(bean - value),
      upBean: 0, //还需多少升级的柠檬数量
      upBeanText: '0', //还需多少升级的柠檬数量
      percent: '100%',
    };
  }
}

/**
 * 获得贵族信息
 * @param  {level}  贵族等级
 *
 */
function _getNobilityInfo(level: number) {
  var name = '';
  if (level) {
    name = config.nobility.names[level - 1];
  }
  return {
    name,
  };
}

/**
 * 根据值获取当前 等级
 * @param type
 * @param value
 * @param sIndex
 * @param eIndex
 * @returns {number|*}
 * @private
 */
function _getLevelIndex(
  type: LevelType,
  value: number,
  sIndex: number,
  eIndex: number,
): number {
  var arr = config[type];
  var currentIndex = Math.floor((eIndex + sIndex) / 2);
  var nextIndex = currentIndex + 1;
  var currentValue = arr.values[currentIndex];
  var nextValue = arr.values[nextIndex];

  if (nextIndex === eIndex) {
    if (value >= nextValue) {
      return eIndex;
    }
    if (currentIndex === sIndex) {
      return sIndex;
    }
  }

  if (currentIndex === sIndex) {
    return currentIndex;
  }

  if (value < currentValue) {
    return _getLevelIndex(type, value, sIndex, currentIndex);
  } else {
    return _getLevelIndex(type, value, currentIndex, eIndex);
  }
}

function _getRichInfo(level: number): LevelInfo {
  const max = config.rich.values.length - 1;
  level = level > max ? max : level;
  return {
    level,
    name: config.rich.names[level],
    value: config.rich.values[level],
  };
}

function _getStarInfo(level: number): LevelInfo {
  const max = config.star.values.length - 1;
  level = level > max ? max : level;
  return {
    level,
    name: config.star.names[level],
    value: config.star.values[level],
  };
}

function _getCoinInfo(level: number): CoinLevelInfo {
  const max = config.coin.values.length - 1;
  level = level > max ? max : level;
  const richLevel = _getRichLevel(config.coin.values[level]).level;
  return {
    level,
    richLevel,
    name: `${level}级`,
    value: config.coin.values[level],
  };
}

/**
 * 获得闪星等级信息
 * @param  {Number} coin 柠檬数量
 * @return {Object}      闪星信息
 */
function _getShinningStar(coin: number) {
  let res = {
    isShinning: false,
    icon: '',
    title: '',
    type: 0,
  };

  if (coin >= 500000) {
    res.isShinning = true;
    res.type = 5;
    res.icon = 'star_5';
    res.title = '闪耀5星';
  } else if (coin >= 200000) {
    res.isShinning = true;
    res.type = 4;
    res.icon = 'star_4';
    res.title = '闪耀4星';
  } else if (coin >= 100000) {
    res.isShinning = true;
    res.type = 3;
    res.icon = 'star_3';
    res.title = '闪耀3星';
  } else if (coin >= 50000) {
    res.isShinning = true;
    res.type = 2;
    res.icon = 'star_2';
    res.title = '闪耀2星';
  } else if (coin >= 20000) {
    res.isShinning = true;
    res.type = 1;
    res.icon = 'star_1';
    res.title = '闪耀1星';
  }

  return res;
}

type Options = { coin: number; richLevel: number; coinLevel: number };
type SimpleLevelInfo = { name: string; level: number };
const getRichHtml = ({ coin, richLevel }: Options): string => {
  let res!: SimpleLevelInfo;
  if (typeof coin !== 'undefined') {
    res = _getRichLevel(coin);
  }
  if (typeof richLevel !== 'undefined') {
    res = _getRichInfo(richLevel);
  }

  let { level, name } = res;
  return `<i class="richLV r_${level}" title="${name}" ></i>`;
};
const getCoinHtml = ({ coin, coinLevel }: Options): string => {
  let res!: SimpleLevelInfo;
  if (coin !== undefined) {
    res = _getCoinLevel(coin);
  }
  if (coinLevel !== undefined) {
    res = _getCoinInfo(coinLevel);
  }

  let { level, name } = res;
  return `<i class="coinLV c_${level}" title="${name}" ></i>`;
};

const formatVal = (val: number): string => {
  if (val > 100000000) {
    return ((val / (100 * 10000)) | 0) / 100 + '亿';
  }
  if (val > 10000) {
    return ((val / 10000) | 0) + '万';
  }
  return val + '';
};

export {
  _getStarLevel as getStarLevel,
  _getRichLevel as getRichLevel,
  _getCoinLevel as getCoinLevel,
  _getShinningStar as getShinningStar,
  _getRichInfo as getRichInfo,
  _getStarInfo as getStarInfo,
  _getCoinInfo as getCoinInfo,
  getRichHtml,
  getCoinHtml,
  _getNobilityInfo as getNobilityInfo,
};
